import Component from './cookie'

export default Component